interface CustomWindow extends Window {
  onAssessmentCommonEvents?: (eventLabel: string, eventAction?: string) => void;
}

let nextPrevTimeout: ReturnType<typeof setTimeout> | undefined = undefined;

const fireAssessmentCommonEvents = (eventLabel: string, eventAction?: string) => {
    clearTimeout(nextPrevTimeout);
    nextPrevTimeout = setTimeout(() => {

        try {
            // fire the utag link event
            if ((window as CustomWindow).onAssessmentCommonEvents) {
              (window as CustomWindow).onAssessmentCommonEvents!(eventLabel, eventAction);
            }
        } catch (e) {
            console.log(
              'onAssessmentCommonEvents failed - please check the Assessment Common Events Script'
            );
        }

    }, 100);
};

export default fireAssessmentCommonEvents;
